(function () {
  /* Product card second image.

     DESKTOP: show image 1 normally, swap to image 2 while the cursor is over
     the card, swap back on leave.

     TOUCH: there is no hover, so on a phone these cards would only ever show
     one picture. Instead the swap is driven by scrolling - once a card is
     mostly on screen it holds image 1 briefly, then changes to image 2, and
     reverts when it scrolls away. The pause matters: swapping instantly would
     mean image 1 is never actually seen on a phone.

     Implementation note: this simply swaps the <img> src. Earlier versions
     painted image 2 as a CSS background on the same element, which broke badly
     because the product shots are PNGs with transparent backgrounds - image 2
     showed through the transparent areas all the time, so the two pictures
     looked merged together. One element, one src, no overlays, no blending.

     Image 2 is read live from /products/<handle>.js, so adding a second image
     in Shopify admin is all that is needed. Cards with one image are left
     alone, and image 2 is preloaded so the swap is not a visible download. */

  var STYLE_ID = "bsl-hoverswap-style-v7";

  /* no hover means touch: phones and most tablets */
  var TOUCH = false;
  try { TOUCH = window.matchMedia("(hover: none)").matches; } catch (e) {}

  var HOLD_MS = 500;   /* how long image 1 shows before the swap on touch */
  var IN_RATIO = 0.55; /* card is "on screen" past this */
  var OUT_RATIO = 0.2; /* and "gone" below this */

  var HANDLES = {
    "2500W Ultra Solar Street Light": "2500w-ultra-solar-street-light",
    "3000W Solar Street Light": "3000w-solar-street-light",
    "800W Solar Street Light": "800w-solar-street-light",
    "300W Solar Flood Light": "300w-solar-flood-light",
    "2IN1 Solar/Electric Light": "2in1-solar-electric-light",
    "Commercial Solar Street Light": "commercial-solar-street-light",
    "1800W Solar Street Light With Panel": "1800w-solar-street-light-with-panel",
    "2000W LED Street Light": "2000w-led-street-light",
    "Garden Solar Lamp": "garden-solar-lamp",
    "UFO Solar Street Light": "ufo-solar-street-light",
    "Solar Ceiling Light": "solar-ceiling-light",
    "Solar Fan With Panel": "solar-fan-with-panel",
    "Office Solar Fan With Panel": "office-solar-fan-with-panel",
    "20W LED Solar Outdoor Lights": "20w-led-solar-outdoor-lights",
    "AI 12MP 4 lense Solar CCTV Camera": "ai-12mp-4-lense-solar-cctv-camera",
    "AI 4K Smart Lenes Wired CCTV": "ai-4k-smart-lenes-wired-cctv"
  };

  var second = {};
  var pending = {};

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      /* Image 2 fills the photo panel edge to edge. It used to be letterboxed
         with object-fit:contain on a mist background, which showed as a grey
         border around the scene shots because they are landscape and the well
         is square. Cover crops a little off the sides instead, which is right
         for a scene photo. Image 1 is untouched: the product cut-outs still
         use contain, so nothing gets sliced off a tall pole light.

         The well's own padding is dropped for the duration of the swap so the
         picture actually reaches the corners. :has() does the parent match;
         a browser without it just keeps the padding, which is the old look. */
      "#range .bsl-well img[data-bsl-hs-showing]," +
        ".bsl-well img[data-bsl-hs-showing]," +
        ".card-gallery img[data-bsl-hs-showing]," +
        "img[data-bsl-hs-showing]{object-fit:cover !important;background:transparent !important;" +
        "width:100% !important;height:100% !important;" +
        "max-width:none !important;max-height:none !important}",
      "#range .bsl-well:has(img[data-bsl-hs-showing])," +
        ".bsl-well:has(img[data-bsl-hs-showing])," +
        ".card-gallery:has(img[data-bsl-hs-showing]){padding:0 !important}",
      /* a gentle fade so the change reads as intentional rather than a glitch */
      ".product-grid img,#range img{transition:opacity .18s ease}",
      "img[data-bsl-hs-fading]{opacity:.55}"
    ].join("");
    document.head.appendChild(s);
  }

  function fetchSecond(handle, cb) {
    if (Object.prototype.hasOwnProperty.call(second, handle)) { cb(second[handle]); return; }
    if (pending[handle]) return;
    pending[handle] = true;
    fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var url = null;
        if (p && p.images && p.images.length > 1) {
          url = p.images[1];
          if (url.indexOf("//") === 0) url = window.location.protocol + url;
          url = url.replace(/(\.(?:jpe?g|png|webp))(\?.*)?$/i, "_1200x$1$2");
        }
        second[handle] = url;
        pending[handle] = false;
        if (url) { var pre = new Image(); pre.src = url; }
        cb(url);
      })
      .catch(function () { second[handle] = null; pending[handle] = false; cb(null); });
  }

  function findCard(h3) {
    var el = h3;
    for (var i = 0; i < 6; i++) {
      el = el.parentElement;
      if (!el) return null;
      if (el.querySelector("img")) return el;
    }
    return null;
  }

  function wire(card, handle) {
    var img = card.querySelector("img");
    if (!img) return;

    /* scrub anything left over from earlier versions of this script */
    if (img.style.backgroundImage) img.style.backgroundImage = "";
    img.classList.remove("bsl-hs-on");

    fetchSecond(handle, function (url) {
      if (!url) return;
      if (!document.body.contains(img)) return;
      if (card.getAttribute("data-bsl-hs-bound") === handle) return;
      card.setAttribute("data-bsl-hs-bound", handle);

      var oSrc = null, oSet = null, oSizes = null, showing = false, holdTimer = null;

      function on() {
        if (showing) return;
        showing = true;
        oSrc = img.getAttribute("src");
        oSet = img.getAttribute("srcset");
        oSizes = img.getAttribute("sizes");
        if (oSet !== null) img.removeAttribute("srcset");
        if (oSizes !== null) img.removeAttribute("sizes");
        img.setAttribute("data-bsl-hs-showing", "1");
        img.setAttribute("src", url);
      }

      function off() {
        if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
        if (!showing) return;
        showing = false;
        img.removeAttribute("data-bsl-hs-showing");
        if (oSrc !== null) img.setAttribute("src", oSrc);
        if (oSet !== null) img.setAttribute("srcset", oSet);
        if (oSizes !== null) img.setAttribute("sizes", oSizes);
      }

      if (TOUCH && window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var e = entries[i];
            if (e.intersectionRatio >= IN_RATIO) {
              if (!showing && !holdTimer) holdTimer = setTimeout(function () { holdTimer = null; on(); }, HOLD_MS);
            } else if (e.intersectionRatio <= OUT_RATIO) {
              off();
            }
          }
        }, { threshold: [0, OUT_RATIO, IN_RATIO, 1] });
        io.observe(card);
      } else {
        card.addEventListener("mouseenter", on);
        card.addEventListener("mouseleave", off);
        card.addEventListener("focusin", on);
        card.addEventListener("focusout", off);
      }
    });
  }

  function run() {
    styles();
    var h3s = document.querySelectorAll("h3");
    for (var i = 0; i < h3s.length; i++) {
      var t = (h3s[i].textContent || "").trim();
      var handle = HANDLES[t];
      if (!handle) continue;
      var card = findCard(h3s[i]);
      if (card) wire(card, handle);
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; run(); }, 200);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
})();
